import React, { useCallback, useEffect, useRef, useState } from "react";
import "swiper/css";
import 'swiper/css/pagination';
import { useLocation, useNavigate, useNavigationType } from "react-router-dom";
import "./BonusPage.scss";
import BONUS_API from "../../services/bonus";
import { toast } from "react-toastify";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import API from "../../services";
import { UserDetails } from "../../models/UserDetails";
import { RootState } from "../../models/RootState";
import { setUserDetails } from "../../store/authReducer";
import { connect } from "react-redux";
import BalnceCard from "./../../assets/images/balance-card.svg";
import { AiOutlineInfoCircle, AiOutlineEye } from "react-icons/ai";
import { DateRange } from "../../App";
import { getEnvVariable } from "../../constants/whitelabelEnv";
import { domain } from "../../constants/Branding";
import { useTranslation } from "../../hooks/useTranslation";

interface BalanceCardProps {
    userDetails: UserDetails;
    setUserDetails: (data: any) => void;
    dynamicTextColors?: any;
}

const BonusPage: React.FC<BalanceCardProps> = ({ userDetails, dynamicTextColors }) => {
    const { t } = useTranslation();
    const location = useLocation();
    const { bpCategory, bpType, tId, amount, curType, curCategory, status, dateRange, policyId } = location.state || {} as { bpCategory?: string; bpType?: string; tId?: string; amount?: number; curType?: string; curCategory?: string; status?: string; dateRange?: DateRange; policyId?: string };
    const BrandName = getEnvVariable(domain, 'BRAND_NAME')

    const HISTORY = "History"
    const CLAIM_BONUS = "Claim Bonus"
    const navigate = useNavigate();
    const navigationType = useNavigationType();
    const [bonusPolicyCategory, setBonusPolicyCategory] = useState<string>(bpCategory || "");
    const [bonusPolicyType, setBonusPolicyType] = useState<string>(bpType || "");
    const [depositAmount, setDepositAmount] = useState<number | null>(amount);
    const [transactionId, setTransactionId] = useState<string | null>(tId);
    const [currency, setCurrency] = useState<string | null>(curType);
    const [currencyCategory, setCurrencyCategory] = useState<string | null>(curCategory);
    const [policyDateRange, setPolicyDateRange] = useState<DateRange | null>(dateRange || null);
    const [redeemCount, setRedeemCount] = useState<number>(0);
    const [redeemAmount, setRedeemAmount] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [redeemLoading, setRedeemLoading] = useState<boolean>(false);
    const [hasMore, setHasMore] = useState(true);
    const [bonusData, setBonusData] = useState<any[]>([]);
    const [policyData, setPolicyData] = useState<any[]>([]);
    const [activeTab, setActiveTab] = useState<string>();
    const [nextPage, setNextPage] = useState<string>('');
    const [pageSize] = useState<number>(10);
    const observer = useRef<IntersectionObserver | null>(null);
    const datePickerRef = useRef<HTMLDivElement>(null);
    const [expandedIndexes, setExpandedIndexes] = useState<Set<string>>(new Set());
    const statusMap: Record<string, string> = {
        AWARDED: t("bonus.awarded"),
        REDEEMABLE: t("bonus.redeemable"),
        REDEEMED: t("bonus.redeemed"),
        CANCELLED: t("bonus.cancelled"),
        EXPIRED: t("bonus.expired")
    };
    const categoryMap: Record<string, string> = {
        ALL: t("common.all"),
        DEPOSIT_BONUS: t("bonus.depositBonus"),
        LOSSBACK_BONUS: t("bonus.lossbackBonus"),
        SIGNUP_BONUS: t("bonus.signupBonus"),
        REFERRAL_BONUS: t("bonus.referralBonus"),
    };

    const [bonusCategory, setBonusCategory] = useState<string>("");
    const [policyCategory, setPolicyCategory] = useState<string>("");
    const [bonusCode, setBonusCode] = useState<string>("");
    const [bonusStatus, setBonusStatus] = useState<string>(status ? status : "AWARDED");
    const [showInfo, setShowInfo] = useState<Record<string, boolean>>({});
    const infoRef = useRef<HTMLDivElement>(null);
    const [polId, setPolicyId] = useState<string>(policyId || "");
    const [showPopup, setShowPopup] = useState<{ visible: boolean; data?: any }>({
        visible: false,
        data: null
    });

    // Get dynamic text color classes from Redux instead of calling function
    const pageTextColorClass = dynamicTextColors?.pageTextColorClass || '';
    const inputBoxTextColorClass = dynamicTextColors?.inputBoxTextColorClass || '';
    const buttonTextColorClass = dynamicTextColors?.buttonTextColorClass || '';
    const tabTextColorClass = dynamicTextColors?.tabTextColorClass || '';
    const activeTabTextColorClass = dynamicTextColors?.activeTabTextColorClass || '';

    // bonusCardTextColorClass uses same as pageTextColorClass
    const bonusCardTextColorClass = pageTextColorClass;

    useEffect(() => {
        getuserStats();
        if (transactionId || bpCategory === "LOSSBACK_BONUS") {
            setBonusPolicyCategory(bpCategory || "");
            handleTabClick(CLAIM_BONUS);
        } else {
            handleTabClick(HISTORY);
        }
        if (location.state) {
            navigate(location.pathname, { replace: true });
        }
    }, []);

    const handleInfoClick = (cardId: string) => {
        setShowInfo(prev => ({
            ...prev,
            [cardId]: !prev[cardId]
        }));
        setTimeout(() => {
            setShowInfo(prev => ({
                ...prev,
                [cardId]: false
            }));
        }, 5000); // Hide the info after 3 seconds
    };

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (infoRef.current && !infoRef.current.contains(event.target)) {
                // Close all info popups when clicking outside
                setShowInfo({});
            }
        };

        // Only add event listener if any info is shown
        if (Object.values(showInfo).some(Boolean)) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showInfo]);

    const handleBackClick = () => {
        if (navigationType === 'POP') {
            navigate('/home'); // Go to home
        } else {
            navigate(-1); // Go back
        }
    };

    const toggleAccordion = (index: string) => {
        setExpandedIndexes((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(index)) {
                newSet.delete(index);
            } else {
                newSet.add(index);
            }
            return new Set(newSet); // Create a new Set to trigger a re-render
        });
    };

    const dateFormat = (time: number) => {
        return new Date(time).toLocaleString("en-GB", {
            day: "numeric",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true,
        });
    };

    const formatDate = (date: string) => {
        return new Date(date).toLocaleString("en-GB", {
            day: "numeric",
            month: "short",
            year: "numeric",
        });
    };

    const loadMoreBonuses = useCallback(async (reset = false) => {
        if (!reset && (loading || !hasMore)) return;
        setLoading(true);

        try {
            const params = {
                user_key: sessionStorage.getItem("userKey"),
                page_token: reset ? '' : nextPage,
                page_size: pageSize,
                status: bonusStatus === 'ALL' ? '' : bonusStatus,
                category: bonusCategory === 'ALL' ? '' : bonusCategory,
                sort: "asc",
            };

            const response = await BONUS_API.get('/bonuses', { params });
            const data = response?.data?.bonuses || [];

            if (reset) {
                setBonusData(data);
            } else {
                setBonusData(prev => [...prev, ...data]);
            }

            setHasMore(data.length === pageSize);
            setNextPage(response.data?.next_page_token || '');
        } catch (e) {
            setHasMore(false);
        } finally {
            setLoading(false);
        }
    }, [loading, hasMore, nextPage, pageSize, bonusStatus, bonusCategory]);

    useEffect(() => {
        if (activeTab == HISTORY) {
            setBonusData([]);
            setNextPage('');
            setHasMore(true);
            loadMoreBonuses(true);
        }
    }, [bonusStatus, bonusCategory]);

    useEffect(() => {
        if (activeTab !== HISTORY && policyCategory !== "") {
            getEligibleBonuses("");
        }
    }, [policyCategory]);

    useEffect(() => {
        const handleIntersection = ([entry]: IntersectionObserverEntry[]) => {
            if (entry.isIntersecting && !loading && hasMore) {
                loadMoreBonuses();
            }
        };

        observer.current = new IntersectionObserver(handleIntersection, {
            root: null,
            rootMargin: "20px",
            threshold: 1.0
        });

        const sentinel = document.getElementById("sentinel");
        if (sentinel) observer.current.observe(sentinel);

        return () => {
            if (observer.current && sentinel) {
                observer.current.unobserve(sentinel);
            }
        };
    }, [loading, hasMore]);

    const handleTabClick = (tab: any) => {
        setActiveTab(tab);
        setBonusCode("");
        if (tab === HISTORY) {
            setDepositAmount(0);
            setTransactionId("");
            setCurrency("");
            setCurrencyCategory("");
            setBonusPolicyType("");
            setExpandedIndexes(new Set());
            loadMoreBonuses(true);
            setBonusPolicyCategory("");
            setPolicyId("");
            setPolicyDateRange(null);
        } else if (tab === CLAIM_BONUS) {
            getEligibleBonuses("");
        }
    };

    const getEligibleBonuses = async (code: string) => {
        if (loading) return;
        setLoading(true);
        let response: any;
        try {
            const params = {
                user_key: sessionStorage.getItem("userKey"),
                deposit_transaction_id: transactionId,
                category: bonusPolicyCategory || policyCategory,
                type: bonusPolicyType || "RETROSPECTIVE",
                code: code,
                date_range: policyDateRange,
                policy_id: polId
            };
            response = await BONUS_API.post(`/bonus-policies/eligible`,
                params);

            setPolicyData(response?.data?.policies);

        } catch (e: any) {
            toast.error(e?.response?.data?.message);
            setLoading(false);
            return;
        }
        setLoading(false);

    };

    const getuserStats = async () => {
        let response: any;
        try {
            const params = {
                user_key: sessionStorage.getItem("userKey")
            };
            response = await BONUS_API.post(`/reports/user-bonus-metrics`,
                params);

            setRedeemCount(response?.data?.total_redeemed_count);
            setRedeemAmount(response?.data?.total_redeemed_amount);

        } catch (e: any) {
            toast.error(e?.response?.data?.message);
            return;
        }
    };

    const handleRedeem = async (bonus: any) => {
        if (redeemLoading) return;
        setRedeemLoading(true);
        let response: any;
        try {
            const params = {
                user_key: bonus?.user_key,
            };
            response = await BONUS_API.post(`/bonuses/${bonus?.id}/redeem`, {}, { params });
        } catch (e: any) {
            toast.error(e?.response?.data?.message);
            setRedeemLoading(false);
            return;
        }
        setRedeemLoading(false);

        if (response?.status == 204) {
            getuserStats();
            toast.success(t("bonus.messages.successfullyRedeemed"));
        } else {
            toast.error(response?.data?.message);
        }
        loadMoreBonuses(true);
    };

    const handleClaim = async (policy: any) => {
        if (redeemLoading) return;
        setRedeemLoading(true);
        let response: any;
        try {
            const params = {
                user_key: sessionStorage.getItem("userKey"),
                deposit_transaction_id: transactionId,
                date_range: policyDateRange,
            };
            response = await BONUS_API.post(`/bonus-policies/${policy?.id}/claim`, params);
        } catch (e: any) {
            toast.error(e?.response?.data?.message);
            setRedeemLoading(false);
            return;
        }
        setRedeemLoading(false);
        if (response?.status == 204) {
            setDepositAmount(0);
            setTransactionId("");
            setCurrency("");
            setCurrencyCategory("");
            handleTabClick(HISTORY)
            toast.success(t("bonus.messages.successfullyClaimed"));
        } else {
            toast.error(response?.data?.message);
        }
    };

    const navtoTransactionDetails = async (referenceId: string) => {
        try {
            const userKey = sessionStorage.getItem("userKey");
            const res = await API.post("/account/get-transactions", {
                pageSize: 1,
                userKey: userKey,
                referenceId: referenceId
            });

            if (res.data.status === "RS_OK" && res?.data?.transactions?.length) {
                const transaction = res?.data?.transactions?.[0];
                if (transaction?.referenceId === referenceId) {
                    navigate("/transaction-history-details", { state: { details: transaction, previous: "bonus", status: bonusStatus } });
                }
            }
        } catch (error) {
        }
    }

    const tabs = [
        {
            key: CLAIM_BONUS,
            label: t("bonus.claimBonus"),
            content: (
                <>
                    {!transactionId ? (
                        <>
                            {bonusPolicyCategory?.trim().toUpperCase() === "LOSSBACK_BONUS" ? (
                                <>
                                    <div className="search-section gap-0 grid-gap-0 bg-gray-100 p-4 rounded-lg shadow">
                                        {/* <div className="text-lg font-semibold text-border-color">Transaction Details</div>
                                        <div className="text-sm text-white">
                                            <p><strong>Loss:</strong> {Math.abs(depositAmount || 0)}</p>
                                        </div> */}
                                        <div className="text-sm pt-[10px] text-red-500 font-medium">
                                            {t("bonus.messages.disclaimer")}
                                        </div>
                                    </div>
                                </>
                            ) :
                                (
                                    <> <div className="filters flex flex-wrap gap-3 my-4">
                                        <div className="w-[48%]">
                                            <select
                                                value={policyCategory}
                                                onChange={(e) => setPolicyCategory(e.target.value)}
                                                className={`flex items-center justify-between w-full px-3 py-2 text-xs font-medium whitespace-nowrap rounded-lg border border-solid bg-inputbox-color ${inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                                            >
                                                <option value="" disabled>{t("bonus.selectCategory")}</option>
                                                {Object.entries(categoryMap).map(([key, value]) => (
                                                    <option key={key} value={key}>{value}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                        {BrandName !== 'Seth247' && (
                                            <div className="search-section">
                                            <h2>{t("bonus.redeemBonusWithCouponCode")}</h2>
                                            <div className="search-bar">
                                                <input
                                                    type="text"
                                                    className="coupon-input"
                                                    placeholder={t("bonus.enterCouponCode")}
                                                    value={bonusCode}
                                                    onChange={(e) => setBonusCode(e.target.value)}
                                                />
                                                <button
                                                    className={`search-button ${buttonTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                                                    onClick={() => getEligibleBonuses(bonusCode)}
                                                    disabled={loading}
                                                >
                                                    {loading ? (
                                                        <div className={`animate-spin rounded-full h-6 w-6 border-b-2 ${buttonTextColorClass === 'dark-text' ? 'border-black' : 'border-white'}`}></div>
                                                    ) : (
                                                        t("common.search")
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                        )}
                                    </>
                                )
                            }
                        </>
                    ) : (
                        <div className="search-section gap-0 grid-gap-0 bg-gray-100 p-4 rounded-lg shadow">
                            <div className="text-lg font-semibold text-border-color">{t("bonus.transactionDetails")}</div>
                            <div className="text-sm text-white">
                                <p><strong>{t("bonus.amount")}</strong> {depositAmount}</p>
                                <p><strong>{t("common.currency")}:</strong> {currency}</p>
                            </div>
                            <div className="text-xs text-red-500 font-medium">
                                {t("bonus.messages.disclaimer")}
                            </div>
                        </div>
                    )}

                    <div className="relative">
                        {policyData?.length > 0 ? (
                            policyData?.map((row, index) => (
                                <div
                                    key={index}
                                    className="bonus-card w-full mb-2 rounded-lg bg-meitms-color text-white shadow-md overflow-hidden"
                                >
                                    {/* Top Row */}
                                    <div className="flex items-center justify-between px-4 py-2">
                                        <div className="flex flex-col">
                                            <div className="text-sm text-pink-400 font-semibold">
                                                {categoryMap[row?.category] || row?.category}
                                            </div>

                                            {row?.bonus_amount && (
                                                <div className="text-green-400 text-sm font-semibold mt-1">
                                                    {t("bonus.amount")} {row?.bonus_amount.toFixed(2)}
                                                </div>
                                            )}
                                        </div>

                                        <button
                                            className="bg-border-color hover:bg-pink-500 transition-all text-white text-xs font-bold px-4 py-1 rounded-md"
                                            onClick={() => handleClaim(row)}
                                        >
                                            {t("bonus.claim")}
                                        </button>
                                    </div>

                                    {/* Divider */}
                                    <div className="h-[1px] bg-[#55334f] mx-4"></div>

                                    {/* Bottom Row */}
                                    <div className="px-4 py-2">
                                        <div className="text-sm font-medium">{row?.name}</div>
                                        <div className="text-sm text-gray-400 mt-1">{row?.description}</div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="text-center text-gray-400 pt-8">{t("bonus.messages.noEligibleBonuses")}</div>
                        )}

                        {redeemLoading && (
                            <div className="fixed inset-0 loading-spinner flex items-center justify-center py-4">
                                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
                            </div>
                        )}
                    </div>
                </>
            )
        },
        {
            key: HISTORY,
            label: t("bonus.history"),
            content: (
                <>
                    <div className="filters flex flex-wrap gap-3 my-4">
                        <div className="w-[48%]">
                            <select
                                value={bonusStatus}
                                onChange={(e) => setBonusStatus(e.target.value)}
                                className={`flex items-center justify-between w-full px-3 py-2 text-xs font-medium whitespace-nowrap rounded-lg border border-solid bg-inputbox-color ${inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                            >
                                <option value="" disabled>{t("bonus.selectStatus")}</option>
                                {Object.entries(statusMap).map(([key, value]) => (
                                    <option key={key} value={key}>{value}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="flex justify-center mb-2">
                        <div className="mr-16">
                            <span className="inline-block w-2 h-2 bg-blue-500 rounded-full mr-2"></span>{t("common.points")}
                        </div>
                        <div>
                            <span className="inline-block w-2 h-2 bg-yellow-500 rounded-full mr-2"></span>{t("common.playChips")}
                        </div>
                    </div>

                    <div className="relative">
                        {
                            bonusData?.length > 0 ? (
                                bonusData?.map((row, index) => (
                                    <div
                                        key={index}
                                        className="bonus-card bg-meitms-color text-white rounded-xl p-4 mb-4 w-full shadow-lg transition-all duration-300 space-y-1"
                                    >
                                        {/* Header Section */}
                                        <div className="flex justify-between items-start">
                                            <div>
                                                <div className="text-xs text-border-color font-semibold uppercase tracking-wide">
                                                    {categoryMap[row?.category]}
                                                </div>
                                                <div className="mt-1 text-base font-medium">
                                                    {t("bonus.amount")}{" "}
                                                    <span
                                                        className={`inline-block w-2 h-2 rounded-full mr-1 ${row?.reward_type === "POINTS"
                                                            ? "bg-blue-500"
                                                            : row?.reward_type === "PLAY_CHIPS"
                                                                ? "bg-yellow-500"
                                                                : ""
                                                            }`}
                                                    ></span>
                                                    {row?.award_amount.toFixed(2)}
                                                </div>
                                            </div>

                                            <button
                                                className={`px-4 py-1 mt-1 rounded text-sm font-semibold transition ${row.status === "REDEEMABLE"
                                                    ? "bg-border-color hover:bg-pink-500 text-white"
                                                    : "bg-gray-400 text-white cursor-not-allowed"
                                                    }`}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (row.status === "REDEEMABLE") handleRedeem(row);
                                                }}
                                                disabled={row.status !== "REDEEMABLE"}
                                            >
                                                {row.status === "REDEEMABLE" ? t("bonus.redeem") : statusMap[row.status]}
                                            </button>
                                        </div>

                                        {/* Progress Bar / Stars Section */}
                                        <div className="relative mt-15">
                                            {row?.redemption_progress?.length > 0 ? (
                                                <div className="flex gap-1">
                                                    {row.redemption_progress?.map((step: { completed: any }, i: React.Key | null | undefined) => (
                                                        <span key={i}>
                                                            {step.completed ? (
                                                                <span className="text-yellow-400 text-2xl">★</span>
                                                            ) : (
                                                                <span className="text-gray-500 text-2xl">★</span>
                                                            )}
                                                        </span>
                                                    ))}


                                                    {/* Details for Redemption_progress */}
                                                    {row?.redemption_progress?.length > 0 && row?.status !== "CANCELLED" && row?.status !== "EXPIRED" && (
                                                        <AiOutlineEye
                                                            className="absolute text-gray-500 top-2 right-0 text-white text-lg cursor-pointer"
                                                            onClick={() => setShowPopup({ visible: true, data: row })}
                                                        />
                                                    )}
                                                </div>
                                            ) : (
                                                <></>
                                                // Default Progress Bar
                                                // <div className="relative mt-10">
                                                //     <div className="w-full h-4 bg-gray-700 rounded-md overflow-hidden relative">
                                                //         <div
                                                //             className={`h-full transition-all duration-300 ${["CANCELLED", "EXPIRED"].includes(row.status)
                                                //                 ? "bg-red-500"
                                                //                 : "bg-green-500"
                                                //                 }`}
                                                //             style={{
                                                //                 width: `${row?.turnover_required === 0
                                                //                     ? 100
                                                //                     : Math.min((row?.turnover_met / row?.turnover_required) * 100, 100)
                                                //                     }%`,
                                                //             }}
                                                //         ></div>
                                                //     </div>
                                                // </div>
                                            )}
                                        </div>

                                        {/* Footer Section */}
                                        <div className="space-y-2 text-sm text-gray-300">
                                            {["AWARDED", "EXPIRED"].includes(row?.status) && (
                                                <div className="relative" ref={infoRef}>
                                                    <div className="flex items-center justify-between">
                                                        {
                                                            row?.status !== "CANCELLED" && (
                                                                <span className="text-white">
                                                                    <strong>{row?.status === "EXPIRED" ? t("bonus.expiredAt") : t("bonus.expires")}</strong> {formatDate(row?.expiry_time)}
                                                                </span>
                                                            )
                                                        }
                                                        <div className="flex gap-2">
                                                            {row?.reference_id && (
                                                                <div>
                                                                    <AiOutlineEye
                                                                        className="text-white text-lg cursor-pointer"
                                                                        onClick={() => navtoTransactionDetails(row?.reference_id)}
                                                                    />
                                                                </div>
                                                            )}
                                                            <AiOutlineInfoCircle
                                                                className="text-white text-lg cursor-pointer"
                                                                onClick={() => handleInfoClick(row?.id)}
                                                            />
                                                        </div>
                                                    </div>

                                                    {showInfo[row?.id] && (
                                                        <div className="absolute right-0 mt-1 z-10 w-72 p-2 text-sm text-white bg-gray-700 border border-gray-500 rounded-lg shadow-md">
                                                            {row?.redemption_progress?.map(
                                                                (step: { step_type: string; completed: boolean }, index: number) => (
                                                                    <span key={index}>
                                                                        {row?.category === "SIGNUP_BONUS" ? (
                                                                            step.step_type === "CONTACT_SHARE"
                                                                                ? t("bonus.messages.bonusWillExpireContactShare")
                                                                                : step.step_type === "DEPOSIT"
                                                                                    ? t("bonus.messages.bonusWillExpireDeposit")
                                                                                    : step.step_type === "TURNOVER"
                                                                                        ? t("bonus.messages.bonusWillExpireTurnover")
                                                                                        : t("bonus.messages.bonusWillExpireStep").replace("{step}", step.step_type)
                                                                        ) : row?.category === "REFERRAL_BONUS" ? (
                                                                            step.step_type === "CONTACT_SHARE"
                                                                                ? t("bonus.messages.referralBonusWillExpireContactShare")
                                                                                : step.step_type === "DEPOSIT"
                                                                                    ? t("bonus.messages.referralBonusWillExpireDeposit")
                                                                                    : t("bonus.messages.referralBonusWillExpireStep").replace("{step}", step.step_type)
                                                                        ) : (
                                                                            t("bonus.messages.bonusWillExpireTurnoverGeneric")
                                                                        )}
                                                                    </span>
                                                                )
                                                            )}
                                                            <br />
                                                            {t("bonus.expiryTime")} {dateFormat(row?.expiry_time)}
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {row?.notes && (
                                                <div>
                                                    <strong>{t("bonus.note")}</strong> {row.notes}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="text-center text-gray-400 pt-8">{t("bonus.messages.noHistoryAvailable")}</div>
                            )
                        }

                        {showPopup.visible && (
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                                <div className="relative bg-gray-800 text-white p-6 rounded-lg w-96 shadow-lg">
                                    {/* Close Button */}
                                    <button
                                        className="absolute top-[1.5rem] right-[1.5rem] text-gray-300 hover:text-white"
                                        onClick={() => setShowPopup({ visible: false, data: null })}
                                    >
                                        ✕
                                    </button>

                                    <h3 className="text-lg font-semibold mb-4">{t("bonus.bonusProgress")}</h3>

                                    {/* Redemption Steps Section */}
                                    <div className="mb-4">
                                        <h4 className="text-md font-semibold mb-2">{t("bonus.redemptionSteps")}</h4>
                                        <ul className="space-y-2">
                                            {showPopup.data.redemption_progress?.map(
                                                (step: { step_type: string; completed: boolean }, index: number) => (
                                                    <li key={index} className="flex items-start gap-2 text-[13px]">
                                                        <span className="text-green-400 font-bold">{index + 1}.</span>
                                                        <span>
                                                            {step.step_type === "CONTACT_SHARE"
                                                                ? t("bonus.shareContact")
                                                                : step.step_type === "DEPOSIT"
                                                                    ? t("bonus.deposit")
                                                                    : step.step_type === "TURNOVER"
                                                                        ? t("bonus.turnover")
                                                                        : step.step_type}
                                                        </span>
                                                    </li>
                                                )
                                            )}
                                        </ul>
                                    </div>
                                    {/* Wager Section */}

                                    {
                                        showPopup.data.redemption_progress?.some((step: { step_type: string }) => step.step_type === "TURNOVER") && showPopup.data.status !== "REDEEMED" && showPopup.data.status !== "REDEEMABLE" && showPopup.data.status !== "EXPIRED" && (
                                            <>
                                                <div className="mb-4 text-sm space-y-1">
                                                    <div>
                                                        {t("bonus.turnoverMet")} {
                                                            (() => {
                                                                const { status, turnover_met } = showPopup.data;
                                                                const userWager = userDetails?.Wager ?? 0;

                                                                if (status === "AWARDED") {
                                                                    const totalMet = userWager + bonusData
                                                                        .slice(0, bonusData.indexOf(showPopup.data) + 1)
                                                                        .reduce((acc, item) => acc + (item?.turnover_met ?? 0), 0);
                                                                    return totalMet.toFixed(0);
                                                                }
                                                                return (userWager + turnover_met).toFixed(0);
                                                            })()
                                                        }
                                                    </div>
                                                    <div>
                                                        {t("bonus.turnoverRequired")} {
                                                            (() => {
                                                                const { status, turnover_required } = showPopup.data;
                                                                const userWager = userDetails?.Wager ?? 0;

                                                                if (status === "AWARDED") {
                                                                    const totalRequired = userWager + bonusData
                                                                        .slice(0, bonusData.indexOf(showPopup.data) + 1)
                                                                        .reduce((acc, item) => acc + (item?.turnover_required ?? 0), 0);
                                                                    return totalRequired.toFixed(0);
                                                                }
                                                                return (userWager + turnover_required).toFixed(0);
                                                            })()
                                                        }
                                                    </div>
                                                </div>
                                                                                                 {/* Progress Bar Section */}
                                                 <div className="flex items-center gap-2 mb-4">
                                                     <div className="w-full h-4 bg-gray-700 rounded-md overflow-hidden">
                                                         <div
                                                             className="h-full bg-green-500"
                                                             style={{
                                                                 width: `${Math.min(
                                                                     (showPopup?.data?.turnover_met / showPopup?.data?.turnover_required) * 100,
                                                                     100
                                                                 )}%`,
                                                             }}
                                                         ></div>
                                                     </div>
                                                     <span className="text-sm text-white font-medium whitespace-nowrap">
                                                         {Math.min(
                                                             Math.round((showPopup?.data?.turnover_met / showPopup?.data?.turnover_required) * 100),
                                                             100
                                                         )}%
                                                     </span>
                                                 </div>
                                            </>
                                        )
                                    }

                                </div>
                            </div>
                        )}

                        {redeemLoading && (
                            <div className="fixed inset-0 loading-spinner flex items-center justify-center py-4">
                                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
                            </div>
                        )}
                    </div>

                    {loading && (
                        <div className="loading-spinner flex justify-center py-4">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
                        </div>
                    )}
                    <div id="sentinel" className="h-4" />
                </>
            )
        },
    ];

    return (
        <div className="bonus-page flex flex-col w-full pb-[7rem] py-[1rem]">

            <section className="flex flex-col justify-center items-center max-w-[388px]">
                <div className="flex relative flex-col p-4 pb-2 w-full items-center">
                    <img
                        loading="lazy"
                        src={BalnceCard}
                        alt=""
                        className="object-cover absolute inset-0 size-full max-md:min-w-[92vw] md:min-w-[28rem]"
                    />
                    <div className="flex relative flex-col items-center text-center">
                        <div className="text-xs text-zinc-400">{t("bonus.totalWager")}</div>
                        <div className="flex items-center">
                            <div className={`text-lg font-semibold ${bonusCardTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{userDetails?.Wager}</div>
                        </div>
                    </div>
                    <div className="flex relative justify-between w-full">
                        <div>
                            <div className="text-xs text-zinc-400">{t("bonus.redeemCount")}</div>
                            <div className="flex items-center">
                                <div className={`text-lg font-semibold ${bonusCardTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{redeemCount}</div>
                            </div>
                        </div>
                        <div>
                            <div className="text-xs text-zinc-400">{t("bonus.redeemAmount")}</div>
                            <div className="flex items-center">
                                <div className={`text-lg font-semibold ${bonusCardTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>{redeemAmount}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="bonus-tabs">
                <div className="bonus-nav">
                    <div className="navi navi-pills" role="tablist">
                        {tabs.map((tab) => (
                            <div className="navi-item" key={tab.key}>
                                <a
                                    role="tab"
                                    className={`navi-link ${activeTab === tab.key ? `active ${activeTabTextColorClass}` : tabTextColorClass}`}
                                    onClick={() => handleTabClick(tab.key)}
                                >
                                    {tab.label}
                                </a>
                            </div>
                        ))}
                    </div>

                    <div className={`tab-content ${pageTextColorClass}`}>
                        {tabs.map((tab) => (
                            <div
                                key={tab.key}
                                className={`tab-pane fade ${activeTab === tab.key ? "show active" : ""} ${pageTextColorClass}`}
                                id={`tabs-tabpane-${tab.key}`}
                                role="tabpanel"
                            >
                                {activeTab === tab.key && tab.content}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        userDetails: state.userDetails?.userDetails,
        dynamicTextColors: state.userDetails?.dynamicTextColors,
    };
};

const mapDispatchToProps = (dispatch: Function) => {
    return {
        setUserDetails: (data: any) => {
            dispatch(setUserDetails(data));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BonusPage);